// libs
import styled, { css } from 'styled-components'
// themes
import { colors } from 'themes'

export const Wrapper = styled.div<{ disabled: boolean }>`
  padding: 18px;
  border-radius: 6px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  background-color: ${colors.white100};

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      opacity: 0.6;

      ${WidgetTitle} {
        height: unset;
        border: none;
        padding-bottom: 0;
        margin-bottom: 0;
      }
    `};
`

export const WidgetTitle = styled.div`
  height: 50px;
  font-size: 22px;
  border-bottom: 1px solid lightgray;
  margin: 0 -18px 16px;
  padding: 0 16px 16px;
`
